/*
 * Country / currency localization selector (White Label model, HZ-native markup).
 * Self-contained: handles open/close, submitting the native localization form by
 * country_code, and an optional country search filter. Does not depend on
 * theme.Disclosure, so it works in the toolbar, header, footer and mobile drawer.
 */
(function () {
  var VISIBLE = 'disclosure-list--visible';
  var HIDDEN = 'hidden';

  function normalize(str) {
    return (str || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim()
      .toLowerCase();
  }

  function setup(root) {
    if (!root || root.__clInitialised) return;
    root.__clInitialised = true;

    var toggle = root.querySelector('[data-country-localization-toggle]');
    var panel = root.querySelector('[data-country-localization-panel]');
    var input = root.querySelector('[data-country-localization-input]');
    var form = root.closest('form');
    var options = root.querySelectorAll('[data-country-localization-option]');

    if (!toggle || !panel || !input || !form) return;

    function open() {
      panel.classList.add(VISIBLE);
      toggle.setAttribute('aria-expanded', 'true');
      if (search) {
        setTimeout(function () {
          try { search.focus(); } catch (e) {}
        }, 0);
      }
    }

    function close() {
      panel.classList.remove(VISIBLE);
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (panel.classList.contains(VISIBLE)) {
        close();
      } else {
        open();
      }
    });

    Array.prototype.forEach.call(options, function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = option.getAttribute('data-value');
        form.submit();
      });
    });

    // Close on outside click / Escape.
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });
    root.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        close();
        try { toggle.focus(); } catch (e) {}
      }
    });

    // Optional search filter.
    var search = root.querySelector('[data-country-localization-search]');
    var reset = root.querySelector('[data-country-localization-reset]');
    var popular = root.querySelector('[data-country-localization-popular]');
    var mainList = root.querySelector('[data-country-localization-list]');

    if (search && mainList) {
      var items = mainList.querySelectorAll('.country-localization__item');

      function applyFilter() {
        var query = normalize(search.value);
        if (reset) reset.classList.toggle(HIDDEN, !query);
        if (popular) popular.classList.toggle(HIDDEN, !!query);
        Array.prototype.forEach.call(items, function (item) {
          var countryEl = item.querySelector('.country-localization__country');
          var name = normalize(countryEl ? countryEl.textContent : '');
          item.classList.toggle(HIDDEN, !!query && name.indexOf(query) === -1);
        });
        panel.scrollTop = 0;
      }

      search.addEventListener('input', applyFilter);
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });

      if (reset) {
        reset.addEventListener('click', function (event) {
          event.preventDefault();
          search.value = '';
          applyFilter();
          try { search.focus(); } catch (e) {}
        });
      }
    }
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-country-localization]');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  // Re-init when the header/footer section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
